import React from 'react';

/**
 * Logo component with variants.
 * - 'default' | 'header': horizontal logo for site header (SRI DURGA badge + Distribution cursive), positioned inline
 * - 'compact': slightly smaller header variant
 * - 'login': vertical logo (bigger) for login/register pages, admin login, super admin login
 *
 * IMPORTANT: 'header' uses /logo-header.png (horizontal) — must NEVER be used on login pages, favicon, PWA, etc.
 * All other places (favicon, PWA, login screens) must use /logo.png (vertical).
 */
export default function Logo({ variant = 'default', className = '' }) {
    if (variant === 'login') {
        return (
            <a href="/" className={`inline-flex items-center shrink-0 ${className}`} aria-label="Sri Durga Distribution">
                <img src="/logo.png" alt="Sri Durga Distribution" className="w-auto h-20 md:h-24" />
            </a>
        );
    }
    // 'default' | 'header' | 'compact' — use horizontal logo for site header
    const size = variant === 'compact' ? 'h-8 md:h-9' : 'h-10 md:h-12';
    return (
        <a href="/" className={`inline-flex items-center shrink-0 ${className}`} aria-label="Sri Durga Distribution">
            <img src="/logo-header.png" alt="Sri Durga Distribution" className={`w-auto ${size}`} />
        </a>
    );
}
